import type {
  ICaseDocument,
  ICaseUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createCaseDocument,
  updateDocument: updateCaseDocument,
  deleteDocument: deleteCaseDocument,
} = makeDocumentService<ICaseDocument, ICaseUploadDocument>(
  '/api/casedocuments',
  'caseDocument'
)
